import { render, staticRenderFns } from "./Qualificationcertification.vue?vue&type=template&id=2b9bc04a&scoped=true&"
import script from "./Qualificationcertification.vue?vue&type=script&lang=js&"
export * from "./Qualificationcertification.vue?vue&type=script&lang=js&"
import style0 from "./Qualificationcertification.vue?vue&type=style&index=0&id=2b9bc04a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9bc04a",
  null
  
)

export default component.exports